import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import moment from 'moment';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { HttpService } from '../services/http.service';
import { DataService } from '../services/data.service';



@Component({
  selector: 'app-reports',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {
  reports: any[] =  [
    {
      reportName: 'Financial Report Q1',
      reportType: 'Financial',
      patentNumbers: ['P1234567', 'P2345678'],
      createdAt: new Date('2022-01-01T10:00:00')
    },
    {
      reportName: 'Tech Analysis Q2',
      reportType: 'Technical',
      patentNumbers: ['P3456789', 'P4567890', 'P5678901'],
      createdAt: new Date('2022-02-10T09:30:00')
    },
    {
      reportName: 'Operational Overview Q3',
      reportType: 'Operational',
      patentNumbers: ['P6789012'],
      createdAt: new Date('2022-03-20T08:20:00')
    }
  ];
  loading = true;

  constructor(private httpService: HttpService, private dataService:DataService, private router:Router) {}

  ngOnInit(): void {
    let username=this.dataService.username;
    this.httpService.get('/reports?username='+username)
      .then((data: any) => {
        this.reports = data;
        this.loading = false;
      })
      .catch(error => {
        console.error('Error fetching reports:', error);
        this.loading = false;
      });
  }

  // Returns relative date string (e.g., "3 days ago")
  getRelativeDate(date: Date): string {
    return moment(date).fromNow();
  }

  // Returns the exact date string for the tooltip
  getExactDate(date: Date): string {
    return moment(date).format('MMMM Do YYYY, h:mm:ss a');
  }

  // Click handler for a report card
  onCardClick(report: any): void {
    // redirect to /report with reportId as a query parameter
    const reportId = report.reportId;
    // redirect using angular router
    this.router.navigate(['/report'], { queryParams: { reportId } });
  }
}
